import { AxiosError } from 'axios';
import { Modals } from '../../constants/modals';
import { store } from '../../stores/store';
import { ApiResponseStatus } from '../../constants/server';
import { CourierPickupSlot, Shipment } from '../../models/parcelDeliveryMiles';

export const handlePaymentRedirect = async (link?: string) => {
  if (!link) return Promise.resolve();

  const win = window.open(link);
  if (win === null) {
    store.modalStore.open({
      id: Modals.PAYMENT,
      name: Modals.PAYMENT,
      props: { link },
    });
  }

  return Promise.resolve();
};

export const checkRescheduleRequired = (error: unknown) =>
  error instanceof AxiosError &&
  error.response?.status === ApiResponseStatus.CONFLICT;

export const handleReschedule = (
  shipment: Shipment,
  onConfirm?: (slot: CourierPickupSlot) => void,
  modalText?: string
) => {
  store.modalStore.open({
    id: Modals.RESCHEDULE_PARCEL,
    name: Modals.RESCHEDULE_PARCEL,
    props: {
      onClose: () => {
        store.modalStore.close(Modals.RESCHEDULE_PARCEL);
      },
      onConfirm,
      text: modalText,
      shipment,
    },
  });
};
